import React from 'react';

import * as css from './JumpTo.css';

export const JumpTo = ({ children }) => <div className={css.JumpTo}>{children}</div>;
